import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpService } from '../../../../shared/ajs-bridges/http.service';
import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { AntenneTLR } from '../entities/antenne-tlr.entity';

@Injectable({ providedIn: 'root' })
export class AntenneService {
	private path: string;

	private antenneTLRSubService!: BasicDataSubService<AntenneTLR>;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(CachedDataSurveyService) private cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: AntenneService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let antennesChanged$ = this.cachedDataSurveyService.getChangeNotification("Antenne");
		this.antenneTLRSubService = new BasicDataSubService<AntenneTLR>(httpClient, this.path + 'antennes?format=TLR', antennesChanged$);
	}

	// Methode recuperant toutes les antennes.
	public getAntennes(profondeur: number) {
		let url = this.path + 'antennes?format=DTO';
		if (profondeur > 0) {
			url = url + '&p=' + profondeur;
		}
		let result = this.httpService.get(url);
		return result;
	}

	// Methode recuperant toutes les antennes.
	public getCacAntennes(userId: number) {
		let url = this.path + 'antennes/cac/' + userId;
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant de recuperer une antenne a partir de son identifiant.
	public getAntenneById(id: number, profondeur: number) {
		let url = this.path + 'antennes/' + id;
		if (profondeur > 0) {
			url = url + '?p=' + profondeur;
		}
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant de recuperer le perimetre CAC sur une antenne #id
	public getAntenneByIdWithOuvrages(id: number) {
		let url = this.path + 'antennes/' + id + "?format=perimetreCAC";
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant d'ajouter une antenne.
	public create(data: any) {
		let url = this.path + 'antennes/';
		let result = this.httpService.post(url, data);
		return result;
	}

	// Methode permettant de modifier une antenne.
	public update(id: number, data: any) {
		let url = this.path + 'antennes/' + id;
		let result = this.httpService.put(url, data);
		return result;
	}

	// Methode permettant de supprimer un antenne.
	public deleteAntenne(id: number) {
		let url = this.path + 'antennes/' + id;
		let result = this.httpService.delete(url);
		return result;
	}

	public getAntennesByAgence(id: number) {
		let url = this.path + 'antennes/idAgence/' + id;
		let result = this.httpService.get(url);
		return result;
	}


	///////////////////////////////////////////
	// Nouvelles fonctions en pur Angular 12 //
	///////////////////////////////////////////

	// Methode permettant le chargement de toutes les agences
	public getAntenneTLRList(): Observable<AntenneTLR[]> {
		return this.antenneTLRSubService.getList();
	}

	// Methodes permettant le chargement de toutes les agences, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getAntenneTLRMapById(): Observable<Map<number, AntenneTLR>> {
		return this.antenneTLRSubService.getMapById();
	}
	public getAntenneTLRById(id: number): Observable<AntenneTLR> {
		return this.antenneTLRSubService.getKnownById(id, "ParcTLR");
	}
	public getAntenneTLRMapByAgence(): Observable<Map<number, AntenneTLR[]>> {
		return this.antenneTLRSubService.getMapByForeignKey('byAgence', (antenne: AntenneTLR) => antenne.agenceId);
	}
	public getAntenneTLRByAgence(agenceId: number): Observable<AntenneTLR[]> {
		return this.antenneTLRSubService.getByForeignKey('byAgence', (antenne: AntenneTLR) => antenne.agenceId, agenceId);
	}

	// Methode permettant de recuperer les ouvrages assignes a un utilisateur CAC
	public getAntennesTLRByResponsabilite(userId: number, typeResponsabilite: string): Observable<AntenneTLR[]> {
		let url = this.path + 'users/' + typeResponsabilite.toLowerCase() + '/' + userId + '/antennes-assignees';
		return this.httpClient.get<AntenneTLR[]>(url);
	}
}

angular
	.module('auroraApp')
	.service('antennesService', downgradeInjectable(AntenneService));